export default __webpack_public_path__ + "static/media/position-status-3.f55eca7e.svg";